import React, { useReducer, createContext, useContext } from 'react'

import { node, object } from 'prop-types'
import reducer from './reducer'

import { getAcceptTermsPoliceData } from '@Core/SessionStorage/helper'
import initialUserState from './initialUserState'

const getInitialState = () => {
  return {
    ...initialUserState,
    isAcceptedTermsPolice: getAcceptTermsPoliceData(),
  }
}

export const CommanContext = createContext(getInitialState())
export const CommanData = () => useContext(CommanContext)

const CommanProvider = (props) => {
  const { children, initialState } = props
  const [state, dispatch] = useReducer(reducer, initialState)

  return (
    <CommanContext.Provider value={[state, dispatch]}>
      {children}
    </CommanContext.Provider>
  )
}

CommanProvider.propTypes = {
  children: node.isRequired,
  initialState: object,
}

CommanProvider.defaultProps = {
  initialState: getInitialState(),
}

export default CommanProvider
